/* eslint-disable react-hooks/exhaustive-deps */
import { planList } from "./contents";
import "../../assets/scss/pages/membership.scss";
import { DefaultButton } from "../../components/widgets";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { capturePaypalPayment, getClientList, getIpAddress, getUserInfo } from "../../actions/user";
import moment from "moment";
import useAuth from "../../hooks/useAuth";
import PaypalButton from "../../components/widgets/paypal-button";
import { PageHeader } from "../../components";
import CreatableSelect from 'react-select/creatable';

export const CheckoutPage: React.FC = () => {
    const { user, dispatchUser } = useAuth() as any;
    const { id } = useParams();
    const [ip, setIp] = useState("");
    const navigate = useNavigate();
    const [plan, setPlan] = useState<any>({
        title: "",
        items: [],
    });
    const [total, setTotal] = useState<number>(0);
    const [duration, setDuration] = useState<number>(0);
    const monthsByLevel = [1, 3, 6, 12, 48];
    const [clientList, setClientList] = useState<any>([]);
    const [client, setClient] = useState<any>({
        id: -1,
        title: ''
    });

    useEffect(() => {
        getIpAddress().then((res) => setIp(res)).catch(console.warn);
        getClientList({}).then((res: any) => {
            setClientList(res.result);
        });
    }, []);

    useEffect(() => {
        if (user && user.profile && user.profile.membership_level && plan.id && user.profile.membership_level === plan.id) {
            navigate('/profile');
        }
        if (user && user.client.id) {
            setClient({
                id: user.client.id,
                title: user.client.title,
            });
        }
    }, [user, plan, navigate]);

    useEffect(() => {
        if (planList.filter((p: any) => p.key === id).length) {
            planList.forEach((p: any) => {
                if (p.key === id) {
                    setPlan(p);
                }
            });
        } else {
            if (id !== '') navigate('/membership');
        }
    }, [id]);

    useEffect(() => {
        if (plan.price) {
            if (duration === 0) {
                setTotal(Number((plan.price).toFixed(2)));
            } else if (duration === 1) {
                let v = plan.price * 0.6 * 3;
                setTotal(Number(v.toFixed(2)));
            } else if (duration === 2) {
                setTotal(Number((plan.price * 0.5 * 6).toFixed(2)));
            } else if (duration === 3) {
                setTotal(Number((plan.price * 0.4 * 12).toFixed(2)));
            } else if (duration === 4) {
                setTotal(Number((plan.price * 0.3 * 48).toFixed(2)));
            }
        } else {
            setTotal(0);
        }
    }, [duration, plan]);

    const PaypalComponent = () => {
        return (
            <PaypalButton total={total} onApproveOrder={onApproveOrder} />
        )
    };

    useEffect(() => {
        PaypalComponent();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [total]);

    const handleMembership = () => {
        navigate('/membership');
    };

    const onApproveOrder = async (data: any, actions: any) => {
        let plan_id = plan.id;
        if (!plan_id) {
            planList.forEach((p: any) => {
                plan_id = p.id;
            });
        }
        const orderId = data.orderID;
        const token = data.facilitatorAccessToken;
        const months = moment().add(monthsByLevel[duration], "months").format("YYYY-MM-DD hh:mm");
        await capturePaypalPayment({
            orderID: orderId,
            token: token,
            plan: plan_id,
            months: months,
            client: client,
            ip: ip,
        });
        await getUserInfo().then((response) => {
            dispatchUser(response.data.userInfo);
        }).catch(console.warn);
        navigate('/profile');
        window.scrollTo({ top: 0, behavior: 'smooth' });
        // return actions.order.capture().then(function () {
        //     // Your code here after capture the order
        // });
    };


    return (
        <div className="page page-membership page-checkout">
            <PageHeader title={"CHECKOUT"} />
            <div className="uk-container-large mt-4">
                <div className="box-wrapper row">
                    <div className="col-6">
                        <div className="body gap-2 mb-5">
                            <p className="card-caption">{plan.title}</p>
                            <div
                                className={"card card-plan px-3 py-3"}
                            >
                                <ul className="mb-5">
                                    {plan?.items?.map((item: any, index: number) => (
                                        <li key={index} className="mb-4">{item}</li>
                                    ))}
                                </ul>
                                <DefaultButton onClick={handleMembership}>Select other plan</DefaultButton>
                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="body gap-2 mb-2">
                            <p className="card-caption">Select Plan Duration</p>
                            <div
                                className={"card card-duration"}
                            >
                                <div
                                    className={"card-item focus d-flex justify-content-between" + (duration === 4 ? ' active' : '')}
                                    onClick={() => setDuration(4)}
                                >
                                    <div className="d-flex align-items-center">
                                        <input
                                            type={"radio"}
                                            name="duration_op"
                                            checked={duration === 4 ? true : false}
                                        />
                                        <span>48 months</span>
                                        <span className="badge">SAVE 70%</span>
                                    </div>
                                    <div>
                                        <span className="promote">${plan.price}</span>
                                        <span>${(plan.price * 0.3).toFixed(2)} / mo</span>
                                    </div>
                                </div>
                                <div
                                    className={"card-item focus d-flex justify-content-between" + (duration === 3 ? ' active' : '')}
                                    onClick={() => setDuration(3)}
                                >
                                    <div className="d-flex align-items-center">
                                        <input
                                            type={"radio"}
                                            name="duration_op"
                                            checked={duration === 3 ? true : false}
                                        />
                                        <span>12 months</span>
                                        <span className="badge">SAVE 60%</span>
                                    </div>
                                    <div>
                                        <span className="promote">${plan.price}</span>
                                        <span>${(plan.price * 0.4).toFixed(2)} / mo</span>
                                    </div>
                                </div>
                                <div
                                    className={"card-item focus d-flex justify-content-between" + (duration === 2 ? ' active' : '')}
                                    onClick={() => setDuration(2)}
                                >
                                    <div className="d-flex align-items-center">
                                        <input
                                            type={"radio"}
                                            name="duration_op"
                                            checked={duration === 2 ? true : false}
                                        />
                                        <span>6 months </span>
                                        <span className="badge">SAVE 50%</span>
                                    </div>
                                    <div>
                                        <span className="promote">${plan.price}</span>
                                        <span>${(plan.price * 0.5).toFixed(2)} / mo</span>
                                    </div>
                                </div>
                                <div
                                    className={"card-item focus d-flex justify-content-between" + (duration === 1 ? ' active' : '')}
                                    onClick={() => setDuration(1)}
                                >
                                    <div className="d-flex align-items-center">
                                        <input
                                            type={"radio"}
                                            name="duration_op"
                                            checked={duration === 1 ? true : false}
                                        />
                                        <span>3 months</span>
                                        <span className="badge">SAVE 40%</span>
                                    </div>
                                    <div>
                                        <span className="promote">${plan.price}</span>
                                        <span>${(plan.price * 0.6).toFixed(2)} / mo</span>
                                    </div>
                                </div>
                                <div
                                    className={"card-item focus d-flex justify-content-between" + (duration === 0 ? ' active' : '')}
                                    onClick={() => setDuration(0)}
                                >
                                    <div className="d-flex align-items-center">
                                        <input
                                            type={"radio"}
                                            name="duration_op"
                                            checked={duration === 0 ? true : false}
                                        />
                                        <span>1 month</span>
                                    </div>
                                    <div>
                                        <span>${plan.price} / mo</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {(id === 'basic_b2b' || id === 'medium_b2b' || id === 'premium_b2b') && (!user?.client.id) && (
                            <div className="body mb-4">
                                <p className="card-caption">Select Company</p>
                                <CreatableSelect
                                    isClearable
                                    options={clientList?.map((c: any) => ({
                                        value: c.id,
                                        label: c.title
                                    }))}
                                    onChange={(v: any) => {
                                        if (v === null) {
                                            setClient({
                                                id: -1,
                                                title: '',
                                            });
                                        } else {
                                            setClient({
                                                id: v.value,
                                                title: v.label,
                                            });

                                        }
                                    }}
                                    onCreateOption={(v: string) => setClient({
                                        id: -1,
                                        title: v,
                                    })}
                                    value={{
                                        value: client.id,
                                        label: client.title,
                                    }}
                                />
                            </div>
                        )}
                        {(
                            ((id === 'basic_b2b' || id === 'medium_b2b' || id === 'premium_b2b') && (client.id > -1 || client.title !== ''))
                            || (id === 'basic_b2c' || id === 'paid_b2c')
                        ) && (
                                <div className="body gap-2 mb-5">
                                    <p className="card-caption">Payment</p>
                                    <div
                                        className={"card px-3 py-3"}
                                    >
                                        <PaypalComponent />
                                        <div className="d-flex justify-content-between fw-bold">
                                            <span>Total</span>
                                            <span>${total}</span>
                                        </div>
                                    </div>
                                </div>
                            )}
                    </div>
                </div>
            </div>
        </div>
    );
};